import { render, staticRenderFns } from "./DetailAccount.vue?vue&type=template&id=e53ed1a2&scoped=true&"
import script from "./DetailAccount.vue?vue&type=script&lang=js&"
export * from "./DetailAccount.vue?vue&type=script&lang=js&"
import style0 from "./DetailAccount.vue?vue&type=style&index=0&id=e53ed1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53ed1a2",
  null
  
)

export default component.exports